import * as React from 'react'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import { PageNotFound } from './pages/PageNotFound'
import { AppRouterHandler } from './shared/AppRouterHandler'
import { routes } from '../config/routes'
import { PageHome } from './pages/PageHome'
import { PageCatalogList } from './pages/PageCatalogList'
import { PageCatalogConfig } from './pages/PageCatalogConfig'
import { PageCatalogItemList } from './pages/PageCatalogItemList'
import { PageCatalogItemDetail } from './pages/PageCatalogItemDetail'

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <AppRouterHandler />
      <Routes>
        <Route path={routes.home} element={<PageHome />} />
        <Route path={routes.catalogList} element={<PageCatalogList />} />
        <Route path={routes.catalogConfig} element={<PageCatalogConfig />} />
        <Route path={routes.catalogItemList} element={<PageCatalogItemList />} />
        <Route path={routes.catalogItemDetail} element={<PageCatalogItemDetail />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
